import axios from 'axios'
import { PAGAR_ME_API_ENDPOINT } from 'shared/envs'

const baseURL = PAGAR_ME_API_ENDPOINT()

export const pagarmeHttpClient = axios.create({ baseURL })
